import React from 'react'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { SpinnerInlineStyled } from '@mobi/component-library/Common/Spinner/Spinner.styles'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { useSearchParamState } from '@core/Utils/hooks/useSearchParamState'
import { SkeletonLoader } from '@core/Areas/FollowMe/Components/Common/SkeletonLoader'
import type { FollowListTabNav } from '@core/Areas/FollowMe/types'

export const FollowListPageLoader: React.FC = () => {
  const [currentTab] = useSearchParamState<FollowListTabNav>({
    values: ['followers', 'following'],
    defaultValue: 'followers',
    key: 'tab',
  })

  return (
    <MainContainer background='surface300'>
      <PageHeader title={<SpinnerInlineStyled />} />

      <div>
        <Tabs>
          <TabButton
            content='Followers'
            isSelected={currentTab === 'followers'}
            onClick={() => null}
          />
          <TabButton
            content='Following'
            isSelected={currentTab === 'following'}
            onClick={() => null}
          />
        </Tabs>
      </div>

      <SkeletonLoader showOnlyHeader />
    </MainContainer>
  )
}
